module.exports = __webpack_public_path__ + "static/spread-04-b9c9a20c53e4c21b65222c8fd79a7815.jpg";